import { Injectable } from "@angular/core";
import { SentNotificationModel } from "../models/sentnotificationModel";
import { ApiDataService } from "@services/http/ApiDataService";
import { Observable } from "rxjs";
import { SentNotificationOverviewModel } from "../models/sentNotificationOvervieuwModel";

@Injectable()
export class SentMailService extends ApiDataService {
    constructor() {
        super("sentmail");
    }

    getSentMails(): Observable<SentNotificationOverviewModel[]> {
        return this.get<SentNotificationOverviewModel[]>();
    }

    getSentMailDetail(mailId: number): Observable<SentNotificationModel> {
        const url = `/${mailId}`;
        return this.get<SentNotificationModel>(url);
    }
}
